import { render, staticRenderFns } from "./CustomerRateCards.vue?vue&type=template&id=1fbc9a04&scoped=true&"
import script from "./CustomerRateCards.vue?vue&type=script&lang=ts&"
export * from "./CustomerRateCards.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerRateCards.vue?vue&type=style&index=0&id=1fbc9a04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbc9a04",
  null
  
)

export default component.exports